export const earn = {
  jdzb: "Earn coins easily",
  jryd: "Finance is wise and we can make progress together",
  jrbk: "Join Biking to easily earn coins, with unlimited innovation to maximize the benefits of your digital assets",
  zbz: "Earning coins",
  ljsy: "Cumulative income",
  zrsy: "Yesterday's earnings",
  hq: "Current",
  cknh: "Reference annualization",
  sqjd: "Subscription progress",
  sg: "Subscription",
  qbcp: "All products",
  cz: "Reset",
  qx: "Term",
  question1: "1. What is earning money?",
  question1_text: "Earning coins is a one-stop service platform created by BIKING to help users discover opportunities for a variety of currency holding products. Currently, the simple way to earn coins is Yubibao (deposit and withdraw anytime), and more products will be launched in the future to provide users with Provide a wide range of product choices.",
  question2: "2. What is reference annualization?",
  question2_text: "The income from earning tokens is currently the interest on deposited tokens. The reference annualization is the annualization of the interest on deposited tokens. For example, the first 1,000U of a product is based on the reference annualization of 12%, and the first 1,000U beyond the first 1,000U is based on the reference annualization of 2%. The total reference annualization of interest is 14%.",
  question3: "3. When does interest accrual/settlement start?",
  question3_text: "When subscribing for different products, the interest accrual/settlement time may be different. Take the current daily interest-based simple earning of USDT as an example, interest accrues at 2 a.m. (UTC+8) the next day after purchasing a USDT current product. At 5 a.m. (UTC+8) at time T+1 (i.e., purchase time T+2), the interest for the day before the settlement of the next day will be issued;",
  question4: "4. What is the remaining investment?",
  question4_text: "The remaining investment amount is the amount of the financial product you can still subscribe for<br/>The remaining investment amount = total product purchase amount - the amount you have subscribed for",
  xzmbfs: "Select the deposit/buy method",
  nhsyl: "Annualized rate of return and term:",
  sl: "Quantity",
  qitou: "Starting investment",
  max: "Maximum",
  kzcsl: "This is the amount that can be transferred out of the capital account",
  sykt: "Remainder can be invested",
  syktsl: "The remaining investment amount is the amount you can still subscribe for",
  syktsx: "Remaining investment amount = total product purchase amount - the quantity you have subscribed (not greater than the individual investment limit {amount}{coin})",
  jlgz: "Reward Rules",
  jd1: "Ladder 1: First {amount}{coin}",
  ptjl: "Platform Reward",
  jd2: "Ladder 2: Greater than the first {amount}{coin}",
  jd22:"Ladder ",
  jd3: "Ladder 3: Greater than {amount}{coin}",
  grsgsx: "The upper limit of personal subscription is {amount}{coin}",
  gz: "Rules",
  sgsj: "Subscription time",
  xianzai: "Now",
  qxsj: "Interest starting time",
  lxrz: "Interest is recorded",
  c2c: "C2C buy coins",
  lhxz: "Flexible choices, better prices",
  lcjd: "Simple process, quick transaction",
  crszhb: "Deposit digital currency from wallet or exchange",
  zcsl: "Asset quantity",
  dzsy: "Revenue received",
  lcxx: "Financial Management Information",
  zt: "Status",
  sh: "Redemption",
  sgje: "Subscription amount",
  sgzj: "The first {amount}{coin} of subscription funds can earn {value}% annual bonus",
  dyklqje: "Anyone greater than {amount}{coin} can earn {value}% annual reward",
  grsged: "The personal subscription amount is {amount}～{amoun2}{coin}",
  shsl: "Redemption quantity",
  srshsl: "Enter the redemption amount",
  ksh: "Redeemable:",
  haode: "Ok",
  zcsg: "Subscribe again",
  sjdzsl: "Actual quantity received",
  shsj: "Redemption time",
  jssj: "Settlement time",
  sgcg: "Subscription successful",
  shcg: "Redemption successful",
  dq: "Regularly",
  yjsdd: "Settled order",
  jyjl: "Transaction Record",
  hqjdzb: "Earn coins easily with current deposits",
  sy: "Profit",
  wwc: "Not completed",
  xmlx: "Project type",
  hqjdzbcp: "Earn money easily with current deposits. It is a safe financial product created by Biking. It supports deposits and withdrawals 24 hours a day, and interest is calculated by the hour.",
  nh: "Annualization",
  zhzchz: "Account asset transfer, simple and fast",
  qsrsl: "Please enter the quantity",
  yjssymx: "Settled income details",
  mx: "Details",
  qwsmrz: "Go to real-name authentication",
  jxwcsmrz: "1. This activity is limited to users who have completed real-name authentication, and each user has only one chance to participate in this activity",
  dqcked: "2. Each user's fixed deposit amount is {min}~{max}{coin}, and the system automatically redeems it to the account upon maturity",
  cpbntjsh: "3. This product cannot be redeemed in advance",
  anzh: "4. After the product is subscribed, the total pool is 0, and the button is grayed out",
  smrzyh: "The activity is limited to users who have completed real-name authentication,",
  jxcjyc: "Each eligible user can only participate once",
  ygsy: "Estimated income",
  scqx: "Lock period",
  qixian: "{min}th day ({max}th day)",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/earn/en.js